/*
  G36 · INTERFAZ COMPARTIDA (se carga en todas las páginas desde layout/theme.liquid)

  1. Carrito
     - Contador del icono de la cabecera ([data-g36-cart-count]): se actualiza al agregar,
       quitar o cambiar cantidades (evento 'shopify:cart:lines-update' de Horizon, evento
       'g36:cart:updated' de favoritos y /cart.js al volver con el botón "atrás").
     - Al agregar: abre el carrito lateral de Horizon (#cart-drawer). Si no existe
       (p. ej. en /cart), muestra el aviso "Agregado al carrito · Ver carrito".
     - El icono del carrito abre el carrito lateral en vez de ir a /cart (sin JS va a /cart).
     - window.G36Cart.notifyAdded(variantId, qty): para añadidos hechos por fuera del
       formulario de Horizon (vista rápida). Avisa a Horizon para que redibuje el carrito
       lateral y luego lo abre.
  2. Lupa de la cabecera ([data-g36-search-open]): abre la búsqueda predictiva de Horizon.
  3. Pie de página a la vista: pone html.g36-footer-in-view (la pestaña "10% Off" y el
     botón de WhatsApp se esconden para no tapar los enlaces del pie).
  4. Talla obligatoria en la ficha: no viene ninguna marcada; "Agregar al carrito",
     la barra fija y "Comprar ahora" (Releasit) piden "Selecciona una talla" hasta que
     el G elija una. No toca la variante que lee Releasit: solo frena el clic.
  5. Colores en las tarjetas (snippets/g36-card-colors.liquid): pasar el mouse por un color
     cambia la foto de la tarjeta y sus enlaces; en celular el primer toque cambia la foto
     y el segundo abre la ficha en ese color.
  6. Carrito lateral en celular: solo se desliza la lista de productos. Al llegar al final
     de la lista, o al arrastrar sobre la parte fija (encabezado, total, botón), el gesto ya
     no pasa a la página de atrás (en iPhone movía todo el panel y dejaba ver la página).
  7. Complementos en el carrito (snippets/g36-cart-upsell.liquid): elegir color y talla en
     la tarjeta y añadir sin salir del carrito.
*/
(function () {
  if (window.G36Cart) return;

  var html = document.documentElement;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = root + 'cart';

  /* ---------------------------------------------------------------
     1. CARRITO
  --------------------------------------------------------------- */

  var suppressOpen = 0;

  function setCount(count, bump) {
    var n = Math.max(0, parseInt(count, 10) || 0);
    document.querySelectorAll('[data-g36-cart-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.hidden = n === 0;
      if (bump && n > 0) {
        el.classList.remove('is-bumping');
        void el.offsetWidth;
        el.classList.add('is-bumping');
      }
    });
    document.querySelectorAll('[data-g36-cart-link]').forEach(function (a) {
      a.setAttribute('aria-label', n === 0 ? 'Carrito' : n === 1 ? 'Carrito, 1 prenda' : 'Carrito, ' + n + ' prendas');
    });
  }

  function refresh(bump) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count, bump);
        return cart;
      })
      .catch(function () {});
  }

  function getDrawer() {
    var d = document.getElementById('cart-drawer');
    return d && typeof d.open === 'function' ? d : null;
  }

  function openCart() {
    var d = getDrawer();
    if (!d) return false;
    if (!d.isOpen) d.open();
    return true;
  }

  var toastEl = null;
  var toastTimer = null;
  function toast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'g36-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<span>Agregado al carrito</span><span aria-hidden="true">·</span><a href="' + CART_URL + '">Ver carrito</a>';
      document.body.appendChild(toastEl);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4500);
  }

  function feedback() {
    if (!openCart()) toast();
  }

  document.addEventListener('shopify:cart:lines-update', function (event) {
    var action = event.action || (event.detail && event.detail.action);
    var promise = event.promise || (event.detail && event.detail.promise);
    var isAdd = action === 'add';
    var openAfter = isAdd && !suppressOpen;
    Promise.resolve(promise)
      .then(function (result) {
        var detail = result && result.detail;
        var cart = result && result.cart;
        if (detail && detail.didError) {
          refresh(false);
          return;
        }
        var qty = cart && typeof cart.totalQuantity === 'number' ? cart.totalQuantity : null;
        if (qty === null) refresh(isAdd);
        else setCount(qty, isAdd);
        if (openAfter) feedback();
      })
      .catch(function (error) {
        if (!error || error.name !== 'AbortError') refresh(false);
      });
  });

  // Favoritos (assets/g36-wishlist.js) ya trae el carrito completo
  document.addEventListener('g36:cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart) setCount(cart.item_count, true);
  });

  // Volver con "atrás" (bfcache): el número puede estar viejo
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh(false);
  });

  // Icono del carrito → carrito lateral (Ctrl/Cmd + clic sigue abriendo /cart en otra pestaña)
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-g36-cart-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
    if (openCart()) event.preventDefault();
  });

  /**
   * Añadido hecho fuera del formulario de Horizon (vista rápida): avisa a Horizon con el
   * mismo evento que usa su formulario, para que el carrito lateral se redibuje, y abre el
   * carrito. Si el módulo de eventos no carga, al menos actualiza el número y muestra el aviso.
   * @param {string|number} variantId
   * @param {number} quantity
   * @param {{ open?: boolean }} [options]
   */
  /**
   * Carga el módulo de eventos de Shopify (@shopify/events, del import map de Horizon).
   * No se usa import() directo: Shopify minifica los assets .js y lo convierte en require(),
   * que no existe en el navegador. Un <script type="module"> en línea sí respeta el import map.
   */
  var eventsPromise = null;
  function loadEvents() {
    if (window.__g36ShopifyEvents) return Promise.resolve(window.__g36ShopifyEvents);
    if (eventsPromise) return eventsPromise;
    eventsPromise = new Promise(function (resolve, reject) {
      window.__g36ShopifyEventsReady = resolve;
      var script = document.createElement('script');
      script.type = 'module';
      script.textContent =
        "import * as m from '@shopify/events';" +
        'window.__g36ShopifyEvents = m;' +
        'window.__g36ShopifyEventsReady && window.__g36ShopifyEventsReady(m);';
      script.onerror = reject;
      document.head.appendChild(script);
      setTimeout(function () {
        if (!window.__g36ShopifyEvents) reject(new Error('@shopify/events no cargó'));
      }, 5000);
    }).catch(function (error) {
      eventsPromise = null;
      throw error;
    });
    return eventsPromise;
  }

  function notifyAdded(variantId, quantity, options) {
    var open = !options || options.open !== false;
    return loadEvents()
      .then(function (mod) {
        var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
        var deferred = CartLinesUpdateEvent.createPromise();
        if (!open) suppressOpen++;
        document.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'dialog',
            lines: [{ merchandiseId: String(variantId), quantity: Number(quantity) || 1 }],
            promise: deferred.promise
          })
        );
        if (!open) suppressOpen--;
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (ajaxCart) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
              detail: { items: ajaxCart.items, source: 'g36-quick-view', didError: false }
            });
          })
          .catch(function (error) {
            deferred.reject(error);
          });
      })
      .catch(function () {
        return refresh(true).then(function () {
          if (open) toast();
        });
      });
  }

  window.G36Cart = { refresh: refresh, open: openCart, notifyAdded: notifyAdded, toast: toast };

  /* ---------------------------------------------------------------
     2. LUPA
  --------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-g36-search-open]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button) return;
    var modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') {
      event.preventDefault();
      modal.showDialog();
    }
  });

  /* ---------------------------------------------------------------
     3. PIE DE PÁGINA A LA VISTA
  --------------------------------------------------------------- */

  function watchFooter() {
    var footer = document.querySelector('body > .page-wrapper > footer, footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        html.classList.toggle('g36-footer-in-view', entry.isIntersecting);
      });
    }).observe(footer);
  }

  /* ---------------------------------------------------------------
     3b. PESTAÑA "10% OFF" (Shopify Forms)
     La app pinta la pestaña y el pop-up dentro de su shadow DOM. Aquí se marca el host
     con [data-g36-teaser] solo mientras se ve la pestaña (no la ventana), para que el
     CSS (assets/g36-apps.css) pueda esconder la pestaña sin tocar el pop-up.
  --------------------------------------------------------------- */

  function watchForms() {
    var hookHost = function (host) {
      if (!host || host.__g36Watched) return;
      var sr = host.shadowRoot;
      if (!sr) return;
      host.__g36Watched = true;
      var update = function () {
        var overlay = sr.querySelector('[class*="_overlay_"]');
        var teaser = sr.querySelector('[class*="_teaser"]');
        host.toggleAttribute('data-g36-teaser', Boolean(teaser) && !overlay);
      };
      update();
      new MutationObserver(update).observe(sr, { childList: true, subtree: true });
    };
    var scan = function () {
      document.querySelectorAll('shopify-forms-embed').forEach(hookHost);
    };
    scan();
    // La app inserta su elemento (y su shadow DOM) un rato después de cargar
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries > 20 || document.querySelector('shopify-forms-embed[data-g36-teaser], shopify-forms-embed')?.__g36Watched) {
        clearInterval(timer);
      }
    }, 750);
  }

  /* ---------------------------------------------------------------
     4. TALLA OBLIGATORIA (ficha de producto)
  --------------------------------------------------------------- */

  var size = { pending: false, fieldset: null };
  var BUY_SELECTOR = [
    'product-form-component .add-to-cart-button',
    'product-form-component [type="submit"]',
    'sticky-add-to-cart .add-to-cart-button',
    '#rsi_buy_now_button',
    '#floatingBuyNowButton button',
    '#floatingBuyNowButton [role="button"]'
  ].join(',');

  function findSizeFieldset() {
    var picker =
      document.querySelector('main variant-picker[data-template-product-match="true"]') ||
      document.querySelector('main variant-picker');
    if (!picker) return null;
    var sets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      var name = (legend ? legend.textContent : '') + ' ' + (sets[i].getAttribute('data-option-id') || '');
      if (/talla|size/i.test(name)) return sets[i];
    }
    return null;
  }

  function clearSizeMessage() {
    document.querySelectorAll('.g36-size-msg').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-g36-missing]').forEach(function (el) { el.removeAttribute('data-g36-missing'); });
    html.removeAttribute('data-g36-size-error');
  }

  function sizeChosen() {
    if (!size.pending) return;
    size.pending = false;
    html.removeAttribute('data-g36-size-pending');
    clearSizeMessage();
  }

  function askForSize() {
    var fieldset = findSizeFieldset();
    if (!fieldset) {
      sizeChosen();
      return;
    }
    var msg = fieldset.parentNode.querySelector('.g36-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'g36-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Selecciona una talla';
      fieldset.insertAdjacentElement('afterend', msg);
    } else {
      // Releer el aviso a lectores de pantalla
      msg.textContent = '';
      msg.textContent = 'Selecciona una talla';
    }
    // Solo la fila de talla se marca (antes también "Color" se ponía en rojo)
    html.removeAttribute('data-g36-size-error');
    fieldset.removeAttribute('data-g36-missing');
    void fieldset.offsetWidth;
    fieldset.setAttribute('data-g36-missing', '');
    html.setAttribute('data-g36-size-error', '');

    var rect = fieldset.getBoundingClientRect();
    var headerH = 90;
    if (rect.top < headerH || rect.bottom > window.innerHeight - 160) {
      window.scrollTo({ top: window.scrollY + rect.top - headerH - 40, behavior: 'smooth' });
    }
    var first = fieldset.querySelector('input:not([data-option-available="false"])') || fieldset.querySelector('input');
    if (first) first.focus({ preventScroll: true });
  }

  function initSize() {
    if (html.classList.contains('shopify-design-mode')) return;
    if (!document.querySelector('main[data-template^="product"]')) return;
    // Si llegó con una variante elegida (enlace con ?variant=), se respeta
    if (/[?&]variant=/.test(window.location.search)) return;
    var fieldset = findSizeFieldset();
    if (!fieldset) return;
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (inputs.length < 2) return; // talla única: no hay nada que elegir

    inputs.forEach(function (input) {
      if (input.checked) input.checked = false;
      input.setAttribute('data-current-checked', 'false');
    });
    size.pending = true;
    html.setAttribute('data-g36-size-pending', '');

    // Al cambiar de color, Horizon vuelve a pintar el selector con la primera talla marcada.
    // Mientras no hayan elegido talla, se desmarca otra vez.
    var picker = fieldset.closest('variant-picker');
    if (picker && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!size.pending) return;
        var fs = findSizeFieldset();
        if (!fs) return;
        fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
          if (input.checked) input.checked = false;
          if (input.getAttribute('data-current-checked') !== 'false') input.setAttribute('data-current-checked', 'false');
        });
      }).observe(picker, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'data-current-checked'] });
    }

    // Cualquier toque a una talla cuenta como elección (también volver a tocar la S)
    var onPick = function (event) {
      var input = event.target;
      if (!size.pending || !input || input.type !== 'radio') return;
      var fs = input.closest('fieldset');
      if (fs && fs === findSizeFieldset()) sizeChosen();
    };
    document.addEventListener('change', onPick, true);
    document.addEventListener('click', onPick, true);

    // Frena "Agregar al carrito", la barra fija y "Comprar ahora" hasta elegir talla
    var guard = function (event) {
      if (!size.pending) return;
      var target = event.target;
      var button = target && target.closest && target.closest(BUY_SELECTOR);
      if (!button) return;
      if (button.closest('#quick-view-modal, .g36-fav, #cart-drawer')) return;
      // Solo el clic se cancela; en pointerdown/touchstart se corta la propagación (por si la
      // app escucha ahí) sin preventDefault, que en celular anularía el clic.
      event.stopImmediatePropagation();
      if (event.type === 'click') {
        event.preventDefault();
        askForSize();
      }
    };
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
      window.addEventListener(type, guard, { capture: true, passive: true });
    });
    window.addEventListener('click', guard, true);
    window.addEventListener(
      'submit',
      function (event) {
        if (!size.pending) return;
        var form = event.target;
        if (form && form.closest && form.closest('product-form-component')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          askForSize();
        }
      },
      true
    );
  }

  /* ---------------------------------------------------------------
     5. COLORES EN LAS TARJETAS
  --------------------------------------------------------------- */

  function setCardImage(img, srcset) {
    if (!img || !srcset) return;
    img.setAttribute('srcset', srcset);
    img.setAttribute('src', srcset.split(' ')[0]);
    img.setAttribute('loading', 'eager');
  }

  function showCardColor(item) {
    var card = item.closest('.g36-card, .product-card');
    if (!card || item.getAttribute('aria-current') === 'true') return;

    setCardImage(card.querySelector('.g36-img--main, .img-primary, .product-card__img'), item.getAttribute('data-srcset'));
    setCardImage(card.querySelector('.g36-img--look, .img-secondary'), item.getAttribute('data-srcset2'));

    // Los enlaces de la tarjeta (foto y nombre) abren la ficha en ese color
    var href = item.getAttribute('href');
    card.querySelectorAll('a[href]:not([data-g36-cc-item])').forEach(function (link) {
      if (/\/products\//.test(link.getAttribute('href'))) link.setAttribute('href', href);
    });

    item.parentNode.querySelectorAll('[data-g36-cc-item]').forEach(function (other) {
      if (other === item) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
    });
  }

  function initCardColors() {
    document.addEventListener('pointerover', function (event) {
      if (event.pointerType !== 'mouse') return;
      var item = event.target.closest && event.target.closest('[data-g36-cc-item]');
      if (item) showCardColor(item);
    });
    document.addEventListener('focusin', function (event) {
      var item = event.target.closest && event.target.closest('[data-g36-cc-item]');
      if (item) showCardColor(item);
    });
    // Táctil: primer toque = ver ese color; segundo toque = abrir la ficha
    var lastPointer = 'mouse';
    document.addEventListener('pointerdown', function (event) { lastPointer = event.pointerType; }, true);
    document.addEventListener('click', function (event) {
      var item = event.target.closest && event.target.closest('[data-g36-cc-item]');
      if (!item || lastPointer === 'mouse') return;
      if (item.getAttribute('aria-current') !== 'true') {
        event.preventDefault();
        showCardColor(item);
      }
    });
  }

  /* ---------------------------------------------------------------
     6. CARRITO LATERAL: SOLO SE DESLIZA LA LISTA
  --------------------------------------------------------------- */

  function initDrawerScroll() {
    var startX = 0;
    var startY = 0;

    document.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (event.touches.length !== 1) return;
        var dialog = document.querySelector('#cart-drawer dialog[open]');
        // Solo dentro del carrito (el formulario de Releasit y lo demás quedan igual)
        if (!dialog || !(event.target instanceof Element) || !dialog.contains(event.target)) return;

        var dx = event.touches[0].clientX - startX;
        var dy = event.touches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy)) return; // gesto de lado: no se toca

        // Busca la caja con desplazamiento más cercana; si puede moverse en ese sentido, se deja
        var el = event.target;
        while (el && el !== dialog.parentElement) {
          var overflowY = getComputedStyle(el).overflowY;
          if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1) {
            var atTop = el.scrollTop <= 0;
            var atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
            if ((dy > 0 && atTop) || (dy < 0 && atBottom)) event.preventDefault();
            return;
          }
          el = el.parentElement;
        }
        // Parte fija del carrito: no mueve nada
        event.preventDefault();
      },
      { passive: false }
    );
  }

  /* ---------------------------------------------------------------
     7. COMPLEMENTOS EN EL CARRITO (snippets/g36-cart-upsell.liquid)
     Elegir color y talla en la tarjeta y añadir sin salir del carrito. Horizon redibuja
     el carrito al añadir: la tarjeta se va y la barra de envío gratis avanza.
  --------------------------------------------------------------- */

  function upsellVariants(card) {
    if (!card._g36Variants) {
      var json = card.querySelector('[data-g36-upsell-variants]');
      try {
        card._g36Variants = JSON.parse(json ? json.textContent : '[]');
      } catch (e) {
        card._g36Variants = [];
      }
    }
    return card._g36Variants;
  }

  // Valor marcado en cada opción (null si falta, p. ej. la talla)
  function upsellSelection(card) {
    return Array.prototype.map.call(card.querySelectorAll('.g36-upsell__opts'), function (set) {
      var on = set.querySelector('[data-g36-upsell-opt][aria-pressed="true"]');
      return on ? on.getAttribute('data-value') : null;
    });
  }

  function upsellMatch(card, selection) {
    var variants = upsellVariants(card);
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < selection.length; j++) {
        if (selection[j] !== null && variants[i].options[j] !== selection[j]) ok = false;
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function upsellSync(card) {
    var selection = upsellSelection(card);
    var sets = card.querySelectorAll('.g36-upsell__opts');

    // Tachar los valores sin stock con lo demás que está marcado
    Array.prototype.forEach.call(sets, function (set, index) {
      set.querySelectorAll('[data-g36-upsell-opt]').forEach(function (button) {
        var test = selection.slice();
        test[index] = button.getAttribute('data-value');
        var available = upsellVariants(card).some(function (v) {
          return v.available && v.options.every(function (value, k) { return test[k] === null || test[k] === value; });
        });
        if (available) {
          button.removeAttribute('data-unavailable');
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('data-unavailable', '');
          button.setAttribute('aria-disabled', 'true');
          if (button.getAttribute('aria-pressed') === 'true' && set.hasAttribute('data-required')) {
            button.setAttribute('aria-pressed', 'false');
          }
        }
      });
    });

    // Foto del color elegido
    var shown = upsellMatch(card, upsellSelection(card));
    var img = card.querySelector('[data-g36-upsell-img]');
    if (shown && img && shown.img && img.getAttribute('src') !== shown.img) {
      img.setAttribute('srcset', shown.srcset);
      img.setAttribute('src', shown.img);
    }

    var add = card.querySelector('[data-g36-upsell-add]');
    var complete = upsellSelection(card).every(function (value) { return value !== null; });
    if (add && add.getAttribute('data-state') !== 'loading') {
      add.setAttribute('data-state', complete ? 'ready' : 'choose');
      add.textContent = complete ? '+ Añadir' : 'Elige tu talla';
    }
  }

  function upsellAdd(card, add) {
    var selection = upsellSelection(card);
    if (selection.some(function (value) { return value === null; })) {
      card.removeAttribute('data-missing');
      void card.offsetWidth;
      card.setAttribute('data-missing', '');
      return;
    }
    var variant = upsellMatch(card, selection);
    if (!variant || !variant.available) return;

    add.setAttribute('data-state', 'loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) {
            var error = new Error('HTTP ' + response.status);
            error.description = response.status === 422 && (body.description || body.message);
            throw error;
          }
        });
      })
      .then(function () {
        add.textContent = '¡Añadida!';
        return notifyAdded(variant.id, 1);
      })
      .catch(function (error) {
        add.setAttribute('data-state', 'error');
        add.textContent = (error && error.description) || 'Error · intenta de nuevo';
        setTimeout(function () {
          if (add.isConnected && add.getAttribute('data-state') === 'error') upsellSync(card);
        }, 3500);
      });
  }

  function initUpsell() {
    document.addEventListener('click', function (event) {
      var target = event.target instanceof Element ? event.target : null;
      var card = target && target.closest('[data-g36-upsell]');
      if (!card) return;

      var option = target.closest('[data-g36-upsell-opt]');
      if (option) {
        if (option.hasAttribute('data-unavailable')) return;
        var set = option.closest('.g36-upsell__opts');
        set.querySelectorAll('[data-g36-upsell-opt]').forEach(function (button) {
          button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
        });
        card.removeAttribute('data-missing');
        upsellSync(card);
        return;
      }

      var add = target.closest('[data-g36-upsell-add]');
      if (add) upsellAdd(card, add);
    });
  }

  /* --------------------------------------------------------------- */

  var start = function () {
    watchFooter();
    watchForms();
    initSize();
    initCardColors();
    initDrawerScroll();
    initUpsell();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
